import { AllProductListTableFields } from 'enums/AllProductListEnums';
import axiosInstance from 'interceptor/axiosInstance';
import { MetaData } from 'models/MainDashboard/locationDashboard.model';
import {
  ParentProductList,
  ParentProductListQueryParams,
} from 'models/ParentProductList/parentProductList.model';
import { ProductSiblingsList } from 'models/ProductSiblingsList/productSiblingsList.model';
import { useState } from 'react';
import { generatePath } from 'react-router-dom';
import { ApiRoutes } from 'routes/routeConstants/apiRoutes';
import { deserialize, serialize } from 'serializr';
import { FetchProductProps } from 'shared/components/Products/AllProducts/ProductListTable';
import { CategoryOptions } from 'shared/utils/convertOptions';
import { transformData } from 'shared/utils/convertProductSiblingOptions';

const ProductSiblingService = () => {
  const [loading, setLoading] = useState(false);
  const [productSiblings, setProductSiblings] = useState<ProductSiblingsList[]>(
    []
  );
  const [productSiblingsOptions, setProductSiblingsOptions] = useState<
    CategoryOptions[]
  >([]);
  const [parentProducts, setParentProducts] = useState<ParentProductList[]>([]);
  const [parentProductsPaginationMeta, setParentProductsPaginationMeta] = useState<MetaData>();


  const fetchProductSiblings = async (productId: number) => {
    try {
      setLoading(true);
      const url = generatePath(ApiRoutes.FETCH_PRODUCT_SIBLING, { productId });
      const response = await axiosInstance.get(url);
      const data = deserialize(
        ProductSiblingsList,
        response.data?.['products']
      ) as ProductSiblingsList[];

      const transformedOptions = transformData(data);

      setProductSiblings(data);
      setProductSiblingsOptions(transformedOptions as CategoryOptions[]);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const fetchProductList = async (params?: FetchProductProps) => {
    try {
      setLoading(true);
      const desiredParams = serialize(
        ParentProductListQueryParams,
        params as ParentProductListQueryParams
      );
      const response = await axiosInstance.get(ApiRoutes.PRODUCTS_LIST, {
        params: desiredParams,
      });
      const data = deserialize(
        ParentProductList,
        response.data?.['products']
      ) as ParentProductList[];
      const paginationData = deserialize(
        MetaData,
        response.data?.['meta']
      ) as MetaData;
      setParentProducts(data);
      setParentProductsPaginationMeta(paginationData)
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    fetchProductSiblings,
    productSiblings,
    productSiblingsOptions,
    fetchProductList,
    parentProducts,
    parentProductsPaginationMeta
  };
};

export default ProductSiblingService;
